const state = {
  languages: [],
  pendingTranslations: false,
  pendingAvailableLanguages: false,
}

const getters = {}

const actions = {
  getAvailableLanguages({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING_AVAILABLE_LANGUAGES')
      this.api.items.getItems('languages')
        .then(({ data }) => {
          commit('SET_LANGUAGES', data.results)
          commit('SET_PENDING_AVAILABLE_LANGUAGES')
          resolve()
        })
    })
  },
  setPendingTranslations({ commit }) {
    commit('SET_PENDING_TRANSLATIONS')
  },
}

const mutations = {
  SET_PENDING_TRANSLATIONS: state => {
    state.pendingTranslations = !state.pendingTranslations
  },
  SET_PENDING_AVAILABLE_LANGUAGES: state => {
    state.pendingAvailableLanguages = !state.pendingAvailableLanguages
  },
  SET_LANGUAGES(state, languages) {
    state.languages = languages
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
